import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Constants } from '../../core/config/Constants';
import { UtilityService } from '../../core/services/utility.service';
import { ConfirmationService } from 'primeng/components/common/confirmationservice';
import { ContentService } from '../../core/services/content.service';
import { Content } from '../../core/models/content';
import { AngularFireDatabase, AngularFireObject, AngularFireList } from 'angularfire2/database';

@Component({
  selector: 'app-content-form',
  templateUrl: './content-form.component.html',
  styleUrls: ['./content-form.component.css'],
  providers: [ExtraService, UtilityService]
})
export class ContentFormComponent implements OnInit {
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;

  eventID: string;
  contentEmptyId: string = null;
  filename: string = '';
  message: string;

  contentList: Array<Content> = new Array();
  contentDeletedList = new Array<string>();
  checkData: boolean = false;

  constructor(private db: AngularFireDatabase, private extraService: ExtraService, private route: ActivatedRoute, private confirmationService: ConfirmationService,
    private contentService: ContentService, private utilityService: UtilityService, private router: Router) { }

  ngOnInit() {
    this.extraService.changeStateofSideBarButton(true);
    this.extraService.changeSideBar(true);
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      if (id) {
        this.eventID = id;
        this.extraService.setCurrentEventId(id);
        this.checkData = true;
        this.getContntList(id);
      }
    });
  }

  getContntList(id) {
    this.message = null;
    var x = this.contentService.getContentList(id);
    x.snapshotChanges().subscribe(list => {
      if (this.checkData) {
        this.contentDeletedList = new Array();
        this.contentList = new Array();
        list.forEach(element => {
          var y = element.payload.toJSON() as Content;
          y["$key"] = element.key;
          this.contentList[y.position] = (y as Content);
        });
        this.checkData = false;
      }
    });

  }

  upMenuItem(index) {
    if (index != 0) {
      this.swap(index, index - 1);
    }
  }

  downMenuItem(index) {
    if (index != this.contentList.length - 1) {
      this.swap(index, index + 1);
    }
  }

  swap(index1, index2) {
    let data = this.contentList[index1];
    this.contentList[index1] = this.contentList[index2];
    this.contentList[index2] = data;
    console.log(this.contentList);
  }

  confirmDelete(event: Content) {
    this.confirmationService.confirm({
      message: Constants.DELETE_MSG_CONTENT,
      accept: () => {
        this.deleteEvent(event);
      }
    });
  }

  deleteEvent(event: Content) {
    // this.contentDeletedList.push(event.$key);
    let index: number = this.contentList.indexOf(event);
    if (index !== -1) {
      this.contentList.splice(index, 1);
      for (var i = 0; i < this.contentList.length; i++) {
        this.contentList[i].position = i;
      }

      this.contentService.deleteContentId(event, this.eventID, this.contentList).then(res => {
        this.message = "Content deleted Successfully";
        setTimeout(() => {
          this.message = null;
          this.checkData = true;
          this.getContntList(this.eventID);
        }, 1000);
      }).catch(error => {
        console.log(error.message);
      });

      // this.contentService.deleteContentId(event, this.eventID,this.contentList);

      // this.db.list(Constants.EVENT_URL + '/' + this.eventID + Constants.CONTENT_URL).remove(event.$key).then(res => {
      //   this.message = "Content deleted Successfully";
      //   if (this.contentList && this.contentList.length > 0) {
      //     let i = 0;
      //     for (let item of this.contentList) {
      //       console.log(item.$key, item.position);
      //       let key = item.$key;
      //       this.db.object(Constants.EVENT_URL + '/' + this.eventID + Constants.CONTENT_URL + "/" + key).update({ position: item.position }).catch(e => { console.log(e) });
      //       if (i == this.contentList.length - 1) {
      //         setTimeout(() => {
      //           this.message = null;
      //           this.checkData = true;
      //           this.getContntList(this.eventID);
      //         }, 1000);
      //       }
      //       i++;
      //     }
      //   } else {
      //     setTimeout(() => {
      //       this.message = null;
      //       this.checkData = true;
      //       this.getContntList(this.eventID);
      //     }, 1000);
      //   }
      // });
    }

  }

  submit() {
    for (var i = 0; i < this.contentList.length; i++) {
      this.contentList[i].position = i;
    }
    this.contentService.updateContentPosition(this.eventID, this.contentList, this.contentDeletedList);
    if (this.contentDeletedList.length > 0) {
      this.message = "Content deleted Successfully";
    } else {
      this.message = "Content orderd Successfully";
    }
    setTimeout(() => {
      this.message = null;
      this.checkData = true;
    }, 2000);
  }


}



// WEBPACK FOOTER //
// /app/src/app/event/content-form/content-form.component.ts